'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { SocialPost } from '@edusense/features-social-post';
import ReplyTweetComposer from './composers/ReplyTweetComposer';
import StandardTweetComposer from './composers/StandardTweetComposer';
import { prepareSocialPostProps } from './utils/tweetHelpers';
export default function TweetComposerLayout(param) {
    var mode = param.mode, referenceTweet = param.referenceTweet, user = param.user, placeholder = param.placeholder, autoFocus = param.autoFocus, isOpen = param.isOpen, onSubmitAction = param.onSubmitAction, store = param.store, externalSetImages = param.externalSetImages;
    if (mode === 'reply' && referenceTweet) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "mb-4"
        }, /*#__PURE__*/ React.createElement(ReplyTweetHeader, {
            referenceTweet: referenceTweet
        }), /*#__PURE__*/ React.createElement(ReplyTweetComposer, {
            user: user,
            referenceTweet: referenceTweet,
            onSubmitAction: onSubmitAction,
            store: store,
            externalSetImages: externalSetImages
        }));
    }
    // 기본/인용
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-full"
    }, /*#__PURE__*/ React.createElement(StandardTweetComposer, {
        user: user,
        placeholder: placeholder,
        autoFocus: autoFocus,
        isOpen: isOpen,
        mode: mode,
        referenceTweet: mode === 'quote' ? referenceTweet : null,
        onSubmitAction: onSubmitAction,
        store: store,
        externalSetImages: externalSetImages
    }));
}
function ReplyTweetHeader(param) {
    var referenceTweet = param.referenceTweet;
    var socialPostProps = prepareSocialPostProps(referenceTweet);
    if (!socialPostProps) return null;
    return /*#__PURE__*/ React.createElement(SocialPost, _object_spread_props(_object_spread({}, socialPostProps), {
        disableViewTracking: true,
        className: "border border-gray-200 dark:border-gray-800 bg-gray-50 dark:bg-gray-900 rounded-xl mb-4"
    }));
}
